import { faLinkedin, faGithub, faFacebook } from "@fortawesome/free-brands-svg-icons";

const socialLinks = [
  {
    href: "https://www.linkedin.com/in/pham-huy-973886219/",
    icon: faLinkedin,
    color: "text-blue-700 dark:text-blue-500",
    alt: "LinkedIn",
  },
  {
    href: "https://github.com/huypv2002",
    icon: faGithub,
    color: "text-gray-900 dark:text-gray-100",
    alt: "GitHub",
  },
  
  {
    href: "https://www.facebook.com/mavanhuy30",
    icon: faFacebook,
    color: "text-blue-800 dark:text-blue-600",
    alt: "Facebook",
  },
];

export default socialLinks;
